/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SubscriptionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * S'abonner aux notifications push
     * Corps : l'objet `PushSubscription` du navigateur (`endpoint`, `keys.p256dh`, `keys.auth`). Un abonnement existant pour le meme `endpoint` est mis a jour.
     * @returns string
     * @throws ApiError
     */
    public subscriptionCreate(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/push/subscribe',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Envoyer une notification push de test
     * Envoie `title` / `message` a l'utilisateur `id` sur tous ses appareils abonnes. 404 si l'utilisateur n'existe pas.
     * @param id
     * @param title
     * @param message
     * @returns string
     * @throws ApiError
     */
    public subscriptionSend(
        id: string,
        title: string,
        message: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/push/send/{id}/{title}/{message}',
            path: {
                'id': id,
                'title': title,
                'message': message,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
